<script setup>
import Sidebar from '../components/Sidebar.vue'
import { ref } from 'vue'

const isSidebarOpen = ref(false)

const handleSidebarToggle = (isOpen) => {
  isSidebarOpen.value = isOpen
}
</script>

<template>
  <div class="app-container">
    <Sidebar @toggle="handleSidebarToggle" />
    <main class="main-content" :class="{ 'sidebar-open': isSidebarOpen }">
      <slot></slot>
    </main>
  </div>
</template>

<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  width: 100%;
  overflow-x: hidden;
  position: relative;
}

.main-content {
  flex: 1;
  min-height: 100vh;
  margin-left: 80px;
  padding: 20px;
  transition: all 0.3s ease;
  width: calc(100% - 100px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.main-content.sidebar-open {
  margin-left: 270px;
  width: calc(100% - 290px);
}

@media (max-width: 768px) {
  .main-content {
    margin-top: 50px;
    margin-left: 0;
    width: 100%;
    padding: 20px;
    margin-top: 60px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .main-content.sidebar-open {
    margin-left: 0;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .main-content {
    padding: 16px;
    margin-top: 50px;
  }
}
</style> 